// GAVION X1: daily goals and leaderboard.
export const goalsEn = {
  metrics: {
    dials: "Dials",
    inbound: "Inbound",
    conversations: "Conversations",
    demos: "Demos booked",
    deals_won: "Deals won",
  },
  my_day: {
    title: "My day",
    subtitle: "Your goals for today",
    progress: "%{count} of %{target}",
    progress_aria: "%{label}: %{count} of %{target}",
    remaining: "%{smart_count} to go |||| %{smart_count} to go",
    hit: "Goal reached",
    all_hit: "Well done! All of today's goals are reached.",
    no_goals: "No daily goal is set.",
    error: "Could not load your goals.",
  },
  leaderboard: {
    title: "Leaderboard",
    description:
      "Dials, conversations, demos and deals won per rep (today, week, month).",
    period_label: "Leaderboard period",
    periods: {
      today: "Today",
      week: "This week",
      month: "This month",
    },
    rank: "Rank",
    rep: "Rep",
    you: "you",
    leader: "Leader",
    empty: "No active rep.",
    error: "Could not load the leaderboard.",
    see_all: "See the leaderboard",
  },
  settings: {
    title: "Goals",
    intro: "Daily targets shown in “My day”. A target of 0 turns the goal off.",
    defaults: "Default daily goals",
    per_rep: "Goals per rep",
    per_rep_hint: "Leave empty to use the default goal.",
    rep: "Rep",
    no_reps: "No active rep.",
    save: "Save",
    saved: "Goals saved",
    errors: {
      out_of_range: "Enter a whole number between 0 and 1000.",
    },
  },
};
